import { Component, OnInit } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-reporte-medicos-activos',
  templateUrl: './reporte-medicos-activos.component.html',
  styleUrls: ['./reporte-medicos-activos.component.css']
})
export class ReporteMedicosActivosComponent implements OnInit {

  cols = [
    {field: 'nombre_doctor', header: 'Nombre del médico'},
    {field: 'mail_doctor', header: 'Correo electrónico del médico'},
    {field: 'nombre_vendedor', header: 'Nombre del vendedor'},
    {field: 'estado', header: 'Estado'},
  ];
  doctors = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchTerms = {
    nombre_doctor: '',
    mail_doctor: '',
    nombre_vendedor: '',
    estado: ''
  };
  maxVisiblePages: number = 8;
  sortColumn: string = ''; // Columna actual de ordenación
  sortDirection: 'asc' | 'desc' = 'asc'; // Dirección de ordenación

  constructor(private reportesService: ReportesService) { }

  ngOnInit(): void {
    this.reportesService.getActiveDoctors().subscribe(resp => {
      this.doctors = JSON.parse(JSON.stringify(resp));
      this.doctors.forEach(d => {
        switch(d.estatus) {
          case 'AC':
            d.estado = 'Activo';
            break;
          case 'SV':
            d.estado = 'Sin verificar';
            break;
          default:
            d.estado = 'Inactivo';
            break;
        }
      })
    })
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
  
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  get pages(): number[] {
    const totalPages = this.totalPages;
  
    if (totalPages <= this.maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePages / 2);
  
    let startPage = Math.max(1, this.currentPage - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);
  
    if (endPage === totalPages) {
      startPage = totalPages - this.maxVisiblePages + 1;
    }
    if (startPage === 1) {
      endPage = this.maxVisiblePages;
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  
    return pages;
  }

  pgone() {
    this.currentPage = 1;
  }

  sortData(column: string): void {
    // Cambia la dirección de ordenación si se selecciona la misma columna, de lo contrario reinicia a ascendente
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }
  
  exportExcelFil() {
    let fullData = this.filteredData
    const readOpts = {
        cellText: false, 
        cellDates: true,
    };
  // Generar los datos personalizados para exportación
  const dataToExport = fullData.map(item => ({
    'Nombre del médico': item.nombre_doctor || '',
    'Correo electrónico del médico': item.mail_doctor || '',
    'Nombre del vendedor': item.nombre_vendedor || '',
    'Estado': item.estado || '',
  }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
    // Definir el ancho de las columnas
    ws['!cols'] = [
      { wch: 35 }, // ancho para 'Nombre del médico'
      { wch: 35 }, // ancho para 'Correo electrónico del médico'
      { wch: 35 }  // ancho para 'Nombre del vendedor'
    ];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'reporte_médicos_activos.xlsx', readOpts);
  }

  get filteredData(): any[] {
    return this.doctors.filter(item =>
      (!this.searchTerms.nombre_doctor || (item.nombre_doctor && item.nombre_doctor.toLowerCase().includes(this.searchTerms.nombre_doctor.toLowerCase()))) &&
      (!this.searchTerms.mail_doctor || (item.mail_doctor && item.mail_doctor.toLowerCase().includes(this.searchTerms.mail_doctor.toLowerCase()))) &&
      (!this.searchTerms.nombre_vendedor || (item.nombre_vendedor && item.nombre_vendedor.toLowerCase().includes(this.searchTerms.nombre_vendedor.toLowerCase()))) &&
      (!this.searchTerms.estado || (item.estado && item.estado.toLowerCase().includes(this.searchTerms.estado.toLowerCase())))
    );
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(startIndex, startIndex + this.itemsPerPage);
  }

}
